import React, {useState} from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import './navbar.css';

const Menu = () => (
  <>
  <p><a href='#service'>Services</a></p>
  <p><a href='#product'>Products</a></p>
  <p><a href='#hire'>Hire Us</a></p>
  <p><a href='#portfolio'>Portfolio</a></p>
  <p><a href='#resources'>Resources</a></p>
  <p><a href='#about'>About</a></p>
  <p><button type='button'>Contact</button></p>
  </>
)

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className='dane__navbar'>
      <div className='dane__navbar-links'>
        <div className='dane__navbar-links_logo'>
          <a href='#home'><h1>Codersdane</h1></a>
        </div>
      </div>
      <div className='dane__navbar-links_container'>
          <Menu />
        </div>
      {/* <div className='dane__navbar-contact'>
        <p>Follow us</p>
        <button type='button'>Contact</button>
      </div> */}
      <div className='dane__navbar-menu'>
        {toggleMenu
          ? <RiCloseLine color='#0E9384' size={25} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color='#0E9384' size={25} onClick={() => setToggleMenu(true)} />
        }
        {toggleMenu && (
          <div className='dane__navbar-menu_container scale-up-center'>
            <div className='dane__navbar-menu_container-links'>
              <Menu />
            </div>
          </div>
        )}
      </div>
      </div>
  )
}

export default Navbar